import { render, staticRenderFns } from "./DevLibsForm.vue?vue&type=template&id=4d99c456&scoped=true"
import script from "./DevLibsForm.vue?vue&type=script&lang=js"
export * from "./DevLibsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d99c456",
  null
  
)

export default component.exports